<template>
	<div>
		<div class="text-center" v-if="loading>0">
			<b-icon icon="circle-fill" animation="throb" font-scale="4"></b-icon>
		</div>
		<b-alert show v-else-if="error" variant="danger" class="mb-3">{{error?.error||error}}</b-alert>
		<b-form v-else-if="user" @submit.prevent="saveSettings()">
			<b-overlay :show="saving > 0" variant="dark">
				<b-card title="Preferences">
					<b-form-row>
						<b-col cols="12" md="4">
							<b-form-group label="Currency" description="This is used for converting donations amounts for the gift goal widget and the gift widget.">
								<b-select v-model="user.currency_code" :options="currencies" value-field="code" text-field="name"></b-select>
							</b-form-group>
						</b-col>
						<b-col cols="12" md="4">
							<b-form-group label="Language" description="This is used for displaying monetary amounts when bridging messages with a gift value.">
								<b-select v-model="user.language_code" :options="locales" value-field="code" text-field="name"></b-select>
							</b-form-group>
						</b-col>
						<b-col cols="12" md="4">
							<b-form-group :disabled="!user.is_pro">
								<template label>
									<legend class="bv-no-focus-ring col-form-label pt-0">Timezone <b-badge v-if="!$parent.$parent.user.is_pro" variant="warning" to="/account/billing?plan=pro&period=monthly">PRO</b-badge></legend>
								</template>
								<b-select v-model="user.timezone" :options="timezones" value-field="code" text-field="name"></b-select>
								<slot description>
									<small class="form-text text-muted">This is used for automatic stream titles where the <code>{date}</code> tag is used.</small>
								</slot>
							</b-form-group>
						</b-col>
					</b-form-row>
					<b-alert :show="!!saveError" variant="danger" class="my-3">{{saveError&&(saveError.saveError||saveError.toString())}}</b-alert>
					<div class="text-center mt-3">
						<b-button variant="primary" type="submit">Save settings</b-button>
					</div>
				</b-card>
			</b-overlay>
		</b-form>
		<div v-else>NO USER</div>
	</div>
</template>

<script>
export default {
	data() { return {
		loading: 0,
		error: null,
		saving: 0,
		saveError: null,
		user: null,
		currencies: null,
		timezones: null,
		locales: null,
	}},
	async mounted() {
		try {
			this.loading++;
			this.error = null;
			this.saving = 0;
			this.saveError = null;
			await this.load();
		} catch(e) {
			console.error(e);
			this.error = e;
		} finally {
			this.loading--;
		}
	},
	methods: {
		async load() {
			[
				this.currencies,
				this.locales,
				this.timezones,
				this.user,
			] = await Promise.all([
				this.$api.get('currencies'),
				this.$api.get('locales'),
				this.$api.get('timezones'),
				{ ...this.$parent.$parent.user },
			]);

			for(let c of this.currencies) c.name ||= c.code;
		},
		async saveSettings() {
			try {
				this.saveError = null;
				this.saving++;
				await this.$api.post('userData', {
					currency_code: this.user.currency_code,
					language_code: this.user.language_code,
					timezone: this.user.timezone,
				});
				await this.$parent.$parent.loadUserData();
				await this.load();
			} catch(e) {
				console.error(e);
				this.saveError = e;
			} finally {
				this.saving--;
			}
		},
	},
};
</script>
